import { AxiosPromise, AxiosStatic } from "axios";
import {
  CreateInstallAttributionDto,
  CreateInstallAttributionResponse,
} from "../types/InstallAttribution";

export const createInstallAttribution =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    data: CreateInstallAttributionDto
  ): AxiosPromise<CreateInstallAttributionResponse> =>
    await appAxios.post(`${serverURL}/install-attribution`, data, {
      withCredentials: true,
    });
